import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import {Integrations} from '@sentry/tracing';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

declare global {
    interface Window {
        env: any;
    }
}

if (environment.sentryDns != '-') {
    Sentry.init({
        dsn: environment.sentryDns,
        autoSessionTracking: true,
        environment: environment.production ? 'production' : (location.hostname === 'localhost' ? 'local' : 'dev-qa'),
        integrations: [
            new Integrations.BrowserTracing({
                tracingOrigins: ['localhost', /^https:\/\/[A-z0-9\-\_\.]+.dave-cc.com/],
                routingInstrumentation: Sentry.routingInstrumentation,
            }),
        ],


        tracesSampleRate: 1.0,
    });
    if (localStorage.getItem('user_id') === null) {
        localStorage.setItem('user_id', Math.random().toString(36).substr(2));
    }

    Sentry.setUser({
        id: localStorage.getItem('user_id'),
        username: localStorage.getItem('user_id')
    });
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
